import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
import { ImportStatusStyledProps } from './types';
import { ImportStatusCode } from '@bechtel/types';
function getStatusStyles({ status }: ImportStatusStyledProps) {
  switch (status) {
    case ImportStatusCode.SCHEDULED:
      return ({ theme }) => css`
        background-color: ${theme.colors.yellow[300]};
      `;
    case ImportStatusCode.COMPLETED:
      return ({ theme }) => css`
        background-color: ${theme.colors.green[300]};
      `;
    case ImportStatusCode.ERRORED:
      return ({ theme }) => css`
        background-color: ${theme.colors.red[200]};
      `;
    case ImportStatusCode.IN_PROGRESS:
      return ({ theme }) => css`
        background-color: ${theme.colors.blue[200]};
      `;

    default:
      return ({ theme }) => css`
        background-color: ${theme.colors.grey[200]};
      `;
  }
}
export const StatusContainerStyled = styled(Box).attrs({
  px: { sm: '450' },
  py: { sm: '300' },
})<ImportStatusStyledProps>`
  ${({ theme }) => css`
    border-radius: ${theme.radii[600]};
  `}
  ${getStatusStyles}
`;

export const InputTimeStyled = styled.input.attrs({ type: 'Time' })`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    padding: ${theme.spacings['000']} ${theme.spacings[500]};
    border-radius: ${theme.radii[200]};
    border-color: ${theme.colors.grey[300]};
  `}
`;
